import React from 'react';
// Inline SVG to avoid pulling lucide-react into the eagerly-imported Hero
// bundle. Saves ~15-30KB on the main entry chunk for the LCP path.
function WrenchIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" data-id="element-118">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" data-id="element-119" />
    </svg>;
}
export function Hero() {
  return <section className="relative pt-4 pb-8 md:pt-8 md:pb-12 overflow-hidden" aria-label="Presentación del Sistema Maestro de Aluminio" style={{
    contain: 'layout'
  }} data-id="element-120">
      <div className="container mx-auto px-4 relative z-10" data-id="element-121">
        <div className="flex flex-col items-center" data-id="element-122">
          <div className="flex-1 text-center max-w-4xl" data-id="element-123">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-gold/40 bg-gold/10" data-id="element-124">
              <WrenchIcon className="w-3.5 h-3.5 text-gold" data-id="element-125" />
              <span className="text-gold text-xs font-semibold uppercase tracking-wider" data-id="element-126">
                +300 talleres ya lo usan en Argentina
              </span>
            </div>
            <h1 className="md:text-7xl font-bold mb-4 text-[#FFFFFF] text-[30px] leading-[1.05]" data-id="element-127">
              Todo tu taller de aluminio,{' '}
              <span className="text-gold" data-id="element-128">con sistema. Desde hoy.</span>
            </h1>

            <div className="mb-8 relative" data-id="element-129">
              <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true" style={{
              background: 'radial-gradient(circle at center, rgba(212,168,67,0.18) 0%, rgba(212,168,67,0) 60%)'
            }} data-id="element-130"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6TLc9KtkH5TMhVgWdeFj3t/Diseno_sin_titulo_%284%29.webp" alt="Sistema Maestro de Aluminio — El sistema N°1 para carpinteros y armadores" className="mx-auto block w-[280px] md:w-[420px] h-auto relative z-10" width={420} height={420} sizes="(min-width: 768px) 420px, 280px"
            // @ts-ignore
            fetchpriority="high" decoding="async" loading="eager" data-id="element-131" />
            </div>

            <p className="text-base md:text-lg mb-8 max-w-2xl mx-auto text-white/90" data-id="element-132">
              Tablas, planos y presupuestos listos para usar. Menos errores,
              menos desperdicio, más margen.
            </p>

            <button onClick={() => {
            const target = document.getElementById('pack-total');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-colors uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)]" data-id="element-133">
              🔩 → QUIERO ACCEDER HOY
            </button>

            <div className="flex flex-wrap justify-center gap-4 mt-8 mb-6" role="list" aria-label="Características principales" data-id="element-134">
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-135">
                <span className="text-2xl" aria-hidden="true" data-id="element-136">
                  📄
                </span>
                <span className="font-medium text-sm" data-id="element-137">100% PDF</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-138">
                <span className="text-2xl" aria-hidden="true" data-id="element-139">
                  ⚡
                </span>
                <span className="font-medium text-sm" data-id="element-140">Acceso en 5 min</span>
              </div>
              
              
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-141">
              <div className="flex items-center gap-2" data-id="element-142">
                <span className="text-gold" aria-hidden="true" data-id="element-143">
                  🛡️
                </span>
                <span data-id="element-144">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-145">
                <span className="text-gold" aria-hidden="true" data-id="element-146">
                  🔒
                </span>
                <span data-id="element-147">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-148">
                <span className="text-gold" aria-hidden="true" data-id="element-149">
                  💳
                </span>
                <span data-id="element-150">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}